<template>
  <a-modal
    title="差异对比"
    :width="450"
    :visible="visible"
    :maskClosable="false"
    :destroyOnClose="true"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <div class="compare-part">
      <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-item label="第一个日期">
          <a-date-picker valueFormat="YYYY-MM-DD" v-decorator="['dateOne', { rules: [{ required: true, message: '' }] }]" />
        </a-form-item>
        <a-form-item label="第二个日期">
          <a-date-picker valueFormat="YYYY-MM-DD" v-decorator="['dateTwo', { rules: [{ required: true, message: '' }] }]" />
        </a-form-item>
      </a-form>
      <div class="tip">提示：所选日期需求差异值=日期1的数值-日期2的数值</div>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'ComparativeAnalysis',
  data () {
    return {
      visible: false,
      confirmLoading: false,
      // 表单参数
      form: this.$form.createForm(this)
    }
  },
  methods: {
    show () {
      this.visible = true
    },
    // 关闭模态框
    close () {
      this.visible = false
    },
    // 确认
    confirm() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$emit('chooseDate', this.form.getFieldsValue());
          this.visible = false
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
.tip{
  color: #f5222d;
}
</style>
